import { render, staticRenderFns } from "./ChurchEdit.vue?vue&type=template&id=3e04497e"
import script from "./ChurchEdit.vue?vue&type=script&lang=js"
export * from "./ChurchEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports